import { createApp, watch } from 'vue'

import VueCookies from 'vue-cookies'
import "@/utilities/polyfills/promise"
import "@/utilities/featuredetection"
import polyfillInit from "@/utilities/polyfills"
import Bootstrap from "@/Bootstrap"
import router from "@/router"
import store from "@/store"

import moment from 'moment'
import 'moment/locale/da'
import 'moment/locale/en-gb'
import 'moment/locale/de'

import MomentFilters from "@/filters/MomentFilters"
import PricingFilters from "@/filters/PricingFilters"
import PassengerFilters from "@/filters/PassengerFilters"
import ClickOutsideDirective from "@/directives/ClickOutsideDirective"
import MainComponents from "@/plugins/mainComponents"
import ErrorHandler from "@/plugins/errorhandler"
import Analytics from "@/plugins/analytics"
import VueAnnouncer from "@vue-a11y/announcer"

import da from './i18n/translations/midttrafik/da.json'
import en from './i18n/translations/midttrafik/en.json'

import FontAwesome from "@/plugins/font-awesome"
import { createI18n } from 'vue-i18n'

import PrimeVue from 'primevue/config'
import Dialog from 'primevue/dialog'
import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'

// Init i18n
const i18n = createI18n({
  legacy: false,
  locale: 'da',
  fallbackLocale: 'en',
  messages: { da, en },
})

// Synkronisér moment med i18n.locale
moment.locale(i18n.global.locale.value)
watch(i18n.global.locale, (newLocale) => {
  moment.locale(newLocale)
})

// PrimeVue preset
const MyPreset = definePreset(Aura, {
  semantic: {
    overlay: {
      modal: {
        padding: '0'
      }
    }
  },
  components: {
    dialog: {
      root: {
        background: '#F5F5F5',
        color: '#636466',
        overflow: 'hidden',
      }
    }
  }
})

// Init app
let app

Promise.all([polyfillInit()]).then(() => {
  app = createApp(Bootstrap)

  app.config.productionTip = false
  app.use(MomentFilters)
  app.use(PricingFilters)
  app.use(PassengerFilters)
  app.use(ClickOutsideDirective)
  app.use(MainComponents)
  app.use(ErrorHandler)
  app.use(Analytics)
  app.use(VueCookies)
  app.config.globalProperties.$cookies = app.$cookies
  app.use(router)
  app.use(VueAnnouncer, { complementRoute: "" }, router)
  app.use(FontAwesome, { componentName: "font-awesome-icon" })
  app.use(i18n)
  app.use(store)
  app.use(PrimeVue, {
    theme: {
      preset: MyPreset
    }
  })
  app.component('Dialog', Dialog)

  app.mount('#app')
})

export default app
